module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/sold-properties-84a5c7d80448b24c3768191354f816d5.svg";